import { Component, Mixins, Watch } from 'vue-property-decorator';
import IBAlertAmountProps from "@/components/IBAlert/IBAlertAmount/mixins/IBAlertAmountProps";

@Component
export default class IBAlertAmountCore extends Mixins(IBAlertAmountProps) {

	amountMain: string = '';

	amountRemainder: string = '';

	created() {
		this.setAmount();
	}

	setAmount() {
		const amount: string[] = this.amount.toFixed(2).split('.');

		this.amountMain = (+amount[0]).toLocaleString('ru');
		this.amountRemainder = amount[1];
	}

	@Watch('amount')
	amountChanged() {
		this.setAmount();
	}

}